(()=>{
 if(window.__bpLeadTracking)return;
 window.__bpLeadTracking=true;
 const storageKey=formId=>'bypolina:lead:'+location.pathname+':'+formId;
 const read=key=>{try{return JSON.parse(sessionStorage.getItem(key)||'null');}catch{return null;}};
 const write=(key,value)=>{try{sessionStorage.setItem(key,JSON.stringify(value));return true;}catch{return false;}};
 const remove=key=>{try{sessionStorage.removeItem(key);}catch{}};
 document.addEventListener('submit',event=>{
  const form=event.target;
  if(!form.matches?.('.bp-contact-form')||event.defaultPrevented||!form.checkValidity())return;
  const id=window.crypto?.randomUUID?.()||Date.now().toString(36)+'-'+Math.random().toString(36).slice(2);
  write(storageKey(form.id),{id,created:Date.now()});
 });
 const process=()=>document.querySelectorAll('[data-bp-lead-success]').forEach(marker=>{
  if(marker.dataset.bpLeadQueued)return;
  const key=storageKey(marker.dataset.bpLeadForm),pending=read(key);
  if(!pending||typeof pending.id!=='string'||!Number.isFinite(pending.created)||Date.now()-pending.created>1800000)return;
  marker.dataset.bpLeadQueued='true';
  let attempts=0;
  const send=()=>{
   try{
    const accepted=window.ByPolinaTikTok?.trackLead(pending.id,marker.dataset.bpLeadSource);
    if(accepted){if(read(key)?.id===pending.id)remove(key);return;}
   }catch{}
   if(++attempts<120)setTimeout(send,500);else delete marker.dataset.bpLeadQueued;
  };
  send();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',process);else process();
 document.addEventListener('shopify:section:load',process);
 document.addEventListener('visitorConsentCollected',process);
 document.addEventListener('bypolina:tiktok-ready',process);
})();
